// extracted by mini-css-extract-plugin
export default {"root":"wmFs7","iconContainer":"cb0uG","icon":"I221H","badge":"WK2gG","message":"tr0OV"};